/* Move the single native sort field into the mobile filter drawer. The same
   GET form continues to submit sorting and facets together, without duplicates. */
(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('.mc-collection__controls').forEach((form) => {
      if (form.dataset.mobileSortReady) return;
      const sort = form.querySelector('.mc-sort-form');
      const toolbar = form.querySelector('.mc-collection__toolbar');
      const slot = form.querySelector('[data-mc-mobile-sort]');
      if (!sort || !toolbar || !slot) return;
      form.dataset.mobileSortReady = 'true';
      const mobile = window.matchMedia('(max-width: 749px)');
      const arrange = () => {
        if (mobile.matches) slot.append(sort);
        else toolbar.append(sort);
      };
      arrange();
      mobile.addEventListener('change', arrange);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
